import React from 'react';
import { NoteMessage } from 'types';
import date from 'utilities/dates/date';
import { MessageStyled, NoteCardStyled, NoteInformation } from './NoteCard.styles';

interface Props {
  note: NoteMessage;
}
export function NoteCard({ note }: Props) {
  const {
    author: { firstName, lastName },
  } = note;
  return (
    <NoteCardStyled data-testid="note-card">
      <MessageStyled data-testid="note-message">{note.message}</MessageStyled>
      <NoteInformation>
        By {firstName} {lastName} {date.toUSLocale(note.createdAt)}{' '}
        {date.getTime(note.createdAt)}
      </NoteInformation>
    </NoteCardStyled>
  );
}
